'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactNotificationSystem = require('react-notification-system');

var _reactNotificationSystem2 = _interopRequireDefault(_reactNotificationSystem);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ShowMessageContext = require('../../contexts/ShowMessageContext');

var _ShowMessageContext2 = _interopRequireDefault(_ShowMessageContext);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var WithMessage = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(WithMessage, _React$Component);
  (0, _createClass3.default)(WithMessage, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        showMessage: this.showMessage
      };
    }
  }, {
    key: 'show',
    value: function show(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.refs.notificationSystem.addNotification((0, _extends3.default)({
        message: message,
        level: 'info'
      }, options));
    }
  }]);

  function WithMessage(props) {
    (0, _classCallCheck3.default)(this, WithMessage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (WithMessage.__proto__ || Object.getPrototypeOf(WithMessage)).call(this, props));

    _this.showMessage = _this.showMessage.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(WithMessage, [{
    key: 'getValidationErrorString',
    value: function getValidationErrorString(_ref) {
      var validationErrors = _ref.validationErrors;
      var keys = Object.keys(validationErrors);
      var texts = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;
          var code = validationErrors[key];

          if (global.translate) {
            var text = global.translate('errors.' + code, {
              label: key
            });
            texts.push(text);
          } else {
            texts.push(key + ': ' + code);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return texts.join(', ');
    }
  }, {
    key: 'showMessage',
    value: function showMessage(message, options) {
      if (typeof message === 'string') {
        this.show(message, options);
      } else if (message.graphQLErrors) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = message.graphQLErrors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var graphError = _step2.value;

            if (graphError.error === 'validationError') {
              this.show(this.getValidationErrorString(graphError), (0, _extends3.default)({
                level: 'error'
              }, options));
            } else {
              this.show(graphError.message, (0, _extends3.default)({
                level: 'error'
              }, options));
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else if (message.message) {
        this.show(message.message, (0, _extends3.default)({
          level: 'error'
        }, options));
      } else {
        this.show(message, (0, _extends3.default)({
          level: 'error'
        }, options));
      }
    }
  }, {
    key: 'getStyle',
    value: function getStyle() {
      return {
        Containers: {
          DefaultStyle: {
            zIndex: 10001
          }
        },
        NotificationItem: {
          DefaultStyle: {
            margin: '10px 5px 2px 1px',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            borderTop: 'none',
            boxShadow: 'none'
          },
          error: {
            backgroundColor: '#be0606'
          }
        },
        Dismiss: {
          DefaultStyle: {
            display: 'none'
          }
        },
        Action: {
          DefaultStyle: {
            outline: 'none',
            cursor: 'pointer'
          },
          info: {
            backgroundColor: '#fff',
            color: '#000'
          }
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_ShowMessageContext2.default.Provider, {
        value: this.showMessage
      }, this.props.children), _react2.default.createElement(_reactNotificationSystem2.default, {
        ref: 'notificationSystem',
        style: this.getStyle()
      }));
    }
  }]);
  return WithMessage;
}(_react2.default.Component), _class.propTypes = {
  children: _propTypes2.default.node
}, _class.childContextTypes = {
  showMessage: _propTypes2.default.func
}, _temp);
exports.default = WithMessage;